import React from 'react';
import Visibility from '../../components/Visibility';
import { Description, SubTitle } from '../../components/layouts';
import { Chart } from '../../components/Chart';
import './style.scss';
import { getTrack } from '../../helpers';

const track = getTrack({ block: 17 });

export function PerfMobile1() {
  const [chartActive, setChartActive] = React.useState(false);
  const handleUpdate = React.useCallback(
    (e, { calculations }) => {
      const { percentagePassed } = calculations;
      setChartActive(percentagePassed > -0.2 && percentagePassed < 1.2);
    },
    [setChartActive]
  );
  return (
    <Visibility
      fireOnMount
      offset={[-500, 500]}
      onUpdate={handleUpdate}
      className="page-section section-perf-mobile inverted"
      data-track={track}
    >
      <div className="sticky-content" style={{ overflow: 'visible' }}>
        <div>
          <div className="section-content left">
            <SubTitle>12+3GB运存的快感</SubTitle>
            <Description>
              X60 Pro在12GB运存<sup>4</sup>
              的基础上、利用内存融合技术<sup>5</sup>
              ，可以调用3GB内存空间到运存进行使用，即刻享受15GB的运存快感。同时实现内核级重构，打造自然连贯的流畅动效。
            </Description>
            <Chart
              active={chartActive}
              className="chart-1"
              title="重度应用场景下"
              prev={{
                value: 60,
                total: 100,
                valueLabel: '37%',
                title: <span>运存使用效率提升</span>
              }}
              next={{
                value: 100,
                total: 100,
                valueLabel: '58%',
                title: <span>系统后台保活能力提升</span>
              }}
            />
          </div>
        </div>
      </div>
    </Visibility>
  );
}
